// src/plugins/element-components.js
import {
  Backtop,
  Select,
  Option,
  Form,
  FormItem,
  Icon,
  RadioGroup,
  Radio,
  Input,
  Button,
  MessageBox
} from 'element-ui';

const components = [
  Backtop,
  Select,
  Option,
  Form,
  FormItem,
  Icon,
  RadioGroup,
  Radio,
  Input,
  Button
];

export default {
  install(Vue) {
    components.forEach(component => {
      Vue.use(component);
    });

    // 特殊组件处理
    Vue.prototype.$confirm = MessageBox.confirm;
  }
};